<template>
  <div>
    <v-select class="service-code"
              v-model="selectedValue"
              :options="serviceCodes"
              label="display_name"
              style="width: 300px;"
              :disabled="!(serviceTypeId) || !(targetDate)"
              @change="onChange">
    </v-select>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import { useStore } from 'vuex'
import _ from 'underscore'
import Constants from '@/constants'

const props = defineProps({
  modelValue: {
    type: [String, Number, null],
    default: null
  },
  serviceTypeId: {
    type: Number,
    default: null
  },
  targetDate: {
    type: String,
    default: null
  },
  specificOfficeAdditionCd: {
    type: String,
    default: null
  },
  filterByAddition: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['update:modelValue', 'change'])

const store = useStore()
const serviceCodes = ref([])
const isSakura = ref(false)

// Computed
const profile = computed(() => store.state.session.profile)
const getServiceCodes = computed(() => store.getters['session/getServiceCodes'])

// Thay thế ref bằng computed
const selectedValue = computed({
  get: () => {
    return _.find(serviceCodes.value, sc => sc.id === Number(props.modelValue)) || null
  },
  set: (value) => {
    emit('update:modelValue', value?.id || null)
  }
})

// Methods
const onChange = (event) => {
  emit('change', event)
}

const initServiceCode = () => {
  serviceCodes.value = []
  if (props.serviceTypeId) {
    if (isSakura.value) {
      // 「特定事業者加算」未設定は UI 上 ''、既存プラン経由では '000'。
      // filterByAddition が true（既定・Plan 系）なら、未設定は素のコード（'005'）に寄せる。
      // false（Report 用途）なら加算区分での絞り込みを行わず、さくら版全件を返す。
      let additionFilter = null
      if (props.filterByAddition) {
        const cd = props.specificOfficeAdditionCd
        additionFilter = cd && cd !== '000' ? cd : '005'
      }
      serviceCodes.value.push(
        ...getServiceCodes.value(
          props.serviceTypeId,
          props.targetDate,
          additionFilter
        )
      )
    } else {
      serviceCodes.value.push(
        ...getServiceCodes.value(props.serviceTypeId, props.targetDate)
      )
    }
  }
}

// Watchers
watch(() => props.modelValue, (newVal, oldVal) => {
}, { immediate: true })

watch(() => props.serviceTypeId, () => {
  initServiceCode()
})

watch(() => props.targetDate, () => {
  initServiceCode()
})

watch(() => props.specificOfficeAdditionCd, () => {
  initServiceCode()
})

// Lifecycle hooks
onMounted(() => {
  isSakura.value = (Constants.FunctionMask.SAKURA & profile.value.site.function_mask) === Constants.FunctionMask.SAKURA
  initServiceCode()
})
</script>

<style scoped>

</style>
